const formStyles = {
    form: {
        textAlign: 'center'
    },
    formPaper: {
        padding: '32px 40px'
    },
    image: {
        display: 'block',
        margin: '0 auto 16px auto',
        maxWidth: 70,
        maxHeight: 70
    },
    pageTitle: {
        marginBottom: 4
    },
    textField: {
        marginBottom: 20,
        display: 'block'
    },
    button: {
        marginTop: 20,
        position: 'relative'
    },
    customError: {
        marginTop: 8,
        marginBottom: 8,
        color: 'red'
    },
    progress: {
        position: 'absolute'
    }
};

export default formStyles;
